import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

const badgeVariants = cva('inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap', {
  variants: {
    tone: {
      neutral: 'border-transparent bg-muted text-muted-foreground',
      primary: 'border-transparent bg-accent text-accent-foreground',
      success: 'border-transparent bg-success/12 text-success',
      warning: 'border-transparent bg-warning/15 text-warning-strong',
      danger: 'border-transparent bg-destructive/12 text-destructive',
      info: 'border-transparent bg-info/12 text-info',
      outline: 'text-foreground',
    },
  },
  defaultVariants: { tone: 'neutral' },
})

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>['tone']>

export function Badge({ className, tone, ...props }: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />
}
